import Crud from './crud'
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
var crud = new Crud('export-receipt', 'phiếu xuất');

const state = {
    ...crud.state,
    packages: {},
    selected: {
        ID: 0
    }
};
const getters = {
    ...crud.getters,
};
const actions = {
    ...crud.actions,
    getTransactionList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('export-receipt/transactions', data => {
            commit('setTransactionList', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
};
const mutations = {
    ...crud.mutations,
    setTransactionList(state, data) {
        state.packages = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};